import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { TenantSettingsModel } from '@main-application/management/components/turnover-configuration/components/turnover-configuration-elapsed-days-section/models/config.models';
import { WorkflowStepEnumType } from '@shared/enums/workflow-step.enum';
import { RestThresholdsConfiguration } from '@shared/interfaces/thresholds-configuration.interface';
import { TurnoverConfigSection } from '@shared/interfaces/turnover-config.interface';

@Injectable({
  providedIn: 'root',
})
export class TurnoverConfigService {
  constructor(private restApiService: RestapiService) {}

  getTurnoverConfigList(): Observable<TurnoverConfigSection[]> {
    return this.restApiService.getData('AdminPanel/turnoverConfiguration');
  }

  getTurnoverConfigListByWorkflowType(id: WorkflowStepEnumType): Observable<TurnoverConfigSection> {
    return this.restApiService.getData(`AdminPanel/turnoverConfiguration/${id}`);
  }

  updateTurnoverFieldConfiguration(turnoverConfig: TurnoverConfigSection): Observable<boolean> {
    return this.restApiService.update(`AdminPanel/turnoverConfiguration`, turnoverConfig);
  }

  getElapsedDaysThresholds(): Observable<RestThresholdsConfiguration> {
    return this.restApiService.getData('AdminPanel/ElapsedDaysThresholds');
  }

  getTenantSettings(): Observable<TenantSettingsModel> {
    return this.restApiService.getData('adminPanel/tenantSettings');
  }

  saveTenantSettings(
    tenantSettings: Partial<
      Pick<
        TenantSettingsModel,
        | 'disableAllEscalationNotices'
        | 'pmsImportNonRevenueUnits'
        | 'escalationEmailsEnabledForProperties'
        | 'autoMoveToMakeReady'
        | 'doNotEmailWhenAssigneeChanges'
        | 'writeMakeReadyStatus'
        | 'writeAvailableDate'
      >
    >
  ): Observable<TenantSettingsModel> {
    return this.restApiService.post('adminPanel/tenantSettings', tenantSettings);
  }

  getFinishTypes(): Observable<any> {
    return this.restApiService.getData('AdminPanel/FinishTypes');
  }

  addFinishType(body): Observable<any> {
    return this.restApiService.create('AdminPanel/FinishTypes/Add', body);
  }

  updateFinishType(body: any): Observable<any> {
    return this.restApiService.customPatchData('AdminPanel/FinishTypes/Update', body);
  }

  deleteFinishType(id: number): Observable<any> {
    return this.restApiService.delete(`AdminPanel/FinishTypes/Delete/${id}`);
  }

  updateElapsedDaysThresholds(
    thresholdsConfiguration: RestThresholdsConfiguration
  ): Observable<RestThresholdsConfiguration> {
    return this.restApiService.associate('AdminPanel/ElapsedDaysThresholds', thresholdsConfiguration);
  }
}
